export const REASON_FOR_LOAN_APPROVAL = {
    bus_fi: {
        en: 'Strength of business financials',
        es: 'Solidez de las finanzas del negocio'
    },
    credit: {
        en: 'My credit score/history',
        es: 'Mi puntaje/historial de crédito'
    },
    prod: {
        en: 'The strength and/or innovation of my product/service',
        es: 'La solidez y/o innovación de mi producto/servicio'
    },
    relationship: {
        en: 'The relationship I was able to build with CIC staff, committee members, etc.',
        es: 'La relación que pude establecer con el personal de CIC, los miembros del comité, etc.'
    },
    story: {
        en: 'My compelling business story',
        es: 'Mi historia empresarial cautivadora'
    },
    value_prop: {
        en: 'My ability to clearly articulate my value proposition',
        es: 'Mi capacidad para articular claramente mi propuesta de valor'
    },
    community: {
        en: "My business' support for my local community",
        es: 'El apoyo de mi negocio a mi comunidad local'
    },
    impact: {
        en: 'The social impact of my business',
        es: 'El impacto social de mi negocio'
    },
    resources: {
        en: 'My ability to leverage business resources (e.g. mentors, business classes, etc.)',
        es: 'Mi capacidad para aprovechar los recursos empresariales (por ejemplo, mentores, clases de negocios, etc.)'
    },
    collateral: {
        en: 'The strength of my collateral and/or personal guarantee(s).',
        es: 'La solidez de mi garantía y/o aval(es) personal(es).'
    },
    other: {
        en: 'Other',
        es: 'Otro'
    },
    idk: {
        en: "I'm not sure.",
        es: 'No estoy seguro.'
    }
} as Record<string, { en: string; es: string }>;
